import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { menuItems } from "@/constant/data";
import Icon from "@/components/ui/Icon";

const Breadcrumbs = () => {
  const location = useLocation();
  const locationName = location.pathname.replace("/", "");

  const [isHide, setIsHide] = useState(null);
  const [groupTitle, setGroupTitle] = useState("");

  useEffect(() => {
    const currentMenuItem = menuItems.find(
      (item) => item.link === locationName
    );

    const currentChild = menuItems.find((item) =>
      item.child?.find((child) => child.childlink === locationName)
    );

    if (currentMenuItem) {
      setIsHide(currentMenuItem.isHide);
      setGroupTitle("");
    } else if (currentChild) {
      setIsHide(currentChild?.isHide || false);
      setGroupTitle(currentChild?.title);
    } else {
      setIsHide(null);
      setGroupTitle("");
    }
  }, [location, locationName]);

  const crumbClass =
    "inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium text-slate-500 transition hover:bg-stone-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100";

  return (
    <>
      {!isHide ? (
        <nav
          className="font-jakarta mb-4 flex flex-wrap items-center gap-1 md:mb-6"
          aria-label="Breadcrumb"
        >
          <ol className="flex flex-wrap items-center gap-1 rounded-xl border border-stone-200/90 bg-white/90 px-2 py-1.5 shadow-sm dark:border-slate-800 dark:bg-slate-900/80">
            <li>
              <NavLink to="/dashboard" className={crumbClass} end>
                <Icon icon="heroicons-outline:home" className="text-base text-teal-600 dark:text-teal-400" />
                <span className="sr-only">Home</span>
              </NavLink>
            </li>
            {groupTitle ? (
              <>
                <li className="text-slate-300 dark:text-slate-600" aria-hidden>
                  <Icon icon="heroicons:chevron-right" className="text-sm" />
                </li>
                <li>
                  <span className={`${crumbClass} cursor-default capitalize`}>
                    {groupTitle}
                  </span>
                </li>
              </>
            ) : null}
            <li className="text-slate-300 dark:text-slate-600" aria-hidden>
              <Icon icon="heroicons:chevron-right" className="text-sm" />
            </li>
            <li>
              <span className="inline-flex max-w-[min(100vw-8rem,28rem)] truncate rounded-md bg-teal-50 px-2.5 py-1 text-sm font-semibold capitalize text-teal-900 dark:bg-teal-950/50 dark:text-teal-100">
                {locationName.replace(/-/g, " ")}
              </span>
            </li>
          </ol>
        </nav>
      ) : null}
    </>
  );
};

export default Breadcrumbs;
